module.exports = __webpack_public_path__ + "media/images/front/review_star_05-3f6d7d4958328a39f6c818d3701aa738.png";